import React, { useState } from 'react';
import PageTitle from '../components/SEO/PageTitle';
import { Link } from 'react-router-dom';
import RecruiterSignupModal from '../components/Auth/RecruiterSignupModal';
import RecruiterLoginModal from '../components/Auth/RecruiterLoginModal';

const ForRecruiters = () => {
    const [showSignup, setShowSignup] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [showJobSeekerLogin, setShowJobSeekerLogin] = useState(false);
    const [showJobSeekerSignup, setShowJobSeekerSignup] = useState(false);

    return (
        <div className="container mx-auto px-4 py-12 max-w-4xl">
            <PageTitle 
    title="Hire Talent" 
    description="Connect with top graduate talent in South Africa. Post jobs and find the perfect candidates for your company."
/>
            <div className="text-center mb-10">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-gradpath-green to-gradpath-dark rounded-2xl mb-4">
                    <i className="fas fa-handshake text-white text-3xl"></i>
                </div>
                <h1 className="text-3xl md:text-4xl font-bold text-gradpath-dark mb-3">Recruit with GradPath</h1>
                <p className="text-gray-600 text-lg max-w-2xl mx-auto">Connect with top graduate talent in South Africa</p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-all hover:-translate-y-1">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"><i className="fas fa-users text-gradpath-green text-2xl"></i></div>
                    <h3 className="text-lg font-bold text-gradpath-dark mb-2">Access Top Talent</h3>
                    <p className="text-gray-600 text-sm">Connect with recent graduates and entry-level professionals across South Africa</p>
                </div>
                <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-all hover:-translate-y-1">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"><i className="fas fa-bullseye text-gradpath-green text-2xl"></i></div>
                    <h3 className="text-lg font-bold text-gradpath-dark mb-2">Targeted Hiring</h3>
                    <p className="text-gray-600 text-sm">Filter candidates by skills, experience, location, and qualifications</p>
                </div>
                <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-all hover:-translate-y-1">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"><i className="fas fa-file-alt text-gradpath-green text-2xl"></i></div>
                    <h3 className="text-lg font-bold text-gradpath-dark mb-2">Streamlined Process</h3>
                    <p className="text-gray-600 text-sm">Post jobs, review applications, and connect with candidates all in one place</p>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 mb-10">
                <h2 className="text-2xl font-bold text-gradpath-dark mb-6 text-center">How It Works</h2>
                <div className="grid md:grid-cols-4 gap-4">
                    {['Sign Up', 'Get Approved', 'Post Jobs', 'Find Talent'].map((step, i) => (
                        <div key={i} className="text-center">
                            <div className="w-12 h-12 bg-gradpath-green rounded-full flex items-center justify-center mx-auto mb-3"><span className="text-white font-bold text-xl">{i + 1}</span></div>
                            <h4 className="font-semibold text-gray-800">{step}</h4>
                            <p className="text-xs text-gray-500">{['Create your recruiter account', 'We review your application (1-2 days)', 'Start posting job opportunities', 'Review applications and connect'][i]}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="bg-gradient-to-r from-gradpath-green to-gradpath-dark rounded-xl p-8 text-center text-white">
                <h2 className="text-2xl font-bold mb-3">Ready to Start Recruiting?</h2>
                <p className="text-white/90 mb-6">Join GradPath and connect with South Africa's top graduate talent</p>
                <div className="flex flex-wrap gap-4 justify-center">
                    <button onClick={() => setShowSignup(true)} className="bg-white text-gradpath-green hover:bg-gray-100 font-semibold px-8 py-3 rounded-lg transition-all inline-flex items-center gap-2 shadow-lg"><i className="fas fa-user-plus"></i> Sign Up as Recruiter</button>
                    <button onClick={() => setShowLogin(true)} className="bg-white/20 backdrop-blur-sm border border-white/30 hover:bg-white/30 text-white font-semibold px-8 py-3 rounded-lg transition-all inline-flex items-center gap-2"><i className="fas fa-sign-in-alt"></i> Login</button>
                </div>
            </div>

            <RecruiterSignupModal isOpen={showSignup} onClose={() => setShowSignup(false)} onSwitchToLogin={() => { setShowSignup(false); setShowLogin(true); }} onSwitchToJobSeeker={() => { setShowSignup(false); setShowJobSeekerSignup(true); }} />
            <RecruiterLoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} onSwitchToSignup={() => { setShowLogin(false); setShowSignup(true); }} onSwitchToJobSeeker={() => { setShowLogin(false); setShowJobSeekerLogin(true); }} />
        </div>
    );
};

export default ForRecruiters;